@if (dynamicData && !dynamicData.loading && !coreFundService.isLoading()) {
  <!-- Back to Dashboard (Figma 596-5182 / mobile 649-2864) — authenticated Contribute page only -->
  @if (isAuthenticatedRoute) {
    <div class="donate-back-row">
      <app-back-button />
    </div>
  }

  <!-- Form Header -->

  @if (dynamicData.canDonate) {
    @if (constData.customLink) {
      <app-donation-form-header
        variant="givelink"
        [fundName]="charityNameOnly"
        [isLoading]="!formManager.charity.value"
      />
    } @else if (isAuthenticatedRoute) {
      <app-donation-form-header
        variant="auth"
        title="contribute.title"
        subtitle="contribute.subtitle"
      >
        @if (coreFundService.selectedFundId() && coreFundService.funds().length > 0) {
          <app-fund-switcher
            [funds]="coreFundService.funds()"
            [selectedFundId]="coreFundService.selectedFundId()"
            [variant]="'yellow'"
            (fundChanged)="onFundChanged($event)"
          />
        }
      </app-donation-form-header>
    } @else {
      <app-donation-form-header variant="default" />
    }

    <!-- Progress Stepper -->
    <div class="stepper-container">
      <app-stepper [steps]="stepperSteps" [activeStepIndex]="currentStepIndex"> </app-stepper>
    </div>
  }

  <div class="donate-layout-row">
    <div class="form-container" [hidden]="dynamicData.displaySummary || showRedirectDialog">

      <!-- Temporarily hidden per UX request: page feels cleaner without the instructional message -->
      <!-- @if (constData.isPublic) {
        @if (constData.customLink) {
          <div class="info-box mb-25px" [ngClass]="{ 'white-font': constData.isFonte }">
            {{ 'contribute.info.custom_link' | translateLang }}
          </div>
        } @else if (constData.isApplicationAssessment) {
          <div class="info-box mb-25px" [ngClass]="{ 'white-font': constData.isFonte }">
            {{ 'contribute.info.assessment' | translateLang }}
          </div>
        } @else {
          <div class="info-box mb-25px" [ngClass]="{ 'white-font': constData.isFonte }">
            {{ 'contribute.info_banner' | translateLang }}
          </div>
        }
      } -->
        
      @if (dynamicData.canDonate) {
        <div class="form-content">
          <form [formGroup]="donateForm">
            @if (constData.isSwiss) {
              <div formGroupName="countryAndCharityInfo">
                <div class="donate-form-section">
                  <!--STEP Country-->
                  <div class="d-flex align-items-start mb-3">
                    <span class="section-number">1</span>
                    <span class="section-title"
                      >{{ 'contribute.section1.title' | translateLang }}@if (isRequired(formManager.countryDonatingFrom)) {<span class="section-title-required">*</span>}
                    </span>
                  </div>
                  <i class="field-description">{{
                    'contribute.section1.description' | translateLang
                  }}</i>

                  <!-- Country -->
                  <app-country-selector
                    label=""
                    [formControl]="formManager.countryDonatingFrom"
                    [countries]="constData.availableCountries"
                    [required]="isRequired(formManager.countryDonatingFrom)"
                    (countrySelect)="onCountrySelect($event)"
                    (hasNoValue)="onCountryDonatingFromHasNoValue($event)"
                    [placeholder]="'contribute.section1.country.placeholder' | translateLang"
                  />
                  @if (formManager.countryName === countryNames.UKRAINE) {
                    <div class="info-box">
                      <p class="mb-1">
                        {{ 'contribute.ukraine_message' | translateLang | translateCut: 0 }}
                      </p>
                      <ul class="mb-0">
                        <li>
                          {{ 'contribute.ukraine_message' | translateLang | translateCut: 1 }}
                        </li>
                        <li>
                          {{ 'contribute.ukraine_message' | translateLang | translateCut: 2 }}
                        </li>
                        <li>
                          {{ 'contribute.ukraine_message' | translateLang | translateCut: 3 }}
                        </li>
                      </ul>
                    </div>
                  }

                  <!-- Tax Deduction -->
                  @if (dynamicData.displayTaxDeduction && !countryFieldHasNoValue) {
                    <div class="tax-deduction-section">
                      <!-- Question Label -->
                      <div class="tax-deduction-label">
                        {{ 'contribute.tax_deduction.title' | translateLang }}
                      </div>

                      <!-- Helper Text -->
                      <div class="tax-deduction-helper">
                        {{ 'contribute.tax_deduction.description' | translateLang }}
                      </div>

                      <!-- Radio Options -->
                      <div class="tax-deduction-options">
                        <div class="tax-deduction-radio">
                          <p-radiobutton
                            [formControl]="formManager.taxDeduction"
                            [value]="taxDeductionYes"
                            name="tax-deduction"
                            inputId="tax-deduction-yes"
                          />
                          <label for="tax-deduction-yes">
                            {{ 'contribute.tax_deduction.yes' | translateLang }}
                          </label>
                        </div>

                        <div class="tax-deduction-radio">
                          <p-radiobutton
                            [formControl]="formManager.taxDeduction"
                            [value]="taxDeductionNo"
                            name="tax-deduction"
                            inputId="tax-deduction-no"
                          />
                          <label for="tax-deduction-no">
                            {{ 'contribute.tax_deduction.no' | translateLang }}
                          </label>
                        </div>
                      </div>
                    </div>
                  }

                  <!-- Network Member Information -->
                  <!-- South Africa shows its own notice below instead of network-member branding -->
                  @if (
                    dynamicData.displayNetworkMember &&
                    formManager.countryDonatingFrom.value?.networkMember &&
                    !countryFieldHasNoValue &&
                    !isSouthAfricaContribution
                  ) {
                    @if (!formManager.isSwitzerland) {
                      <div class="flex-wrap w-100 my-3 network-member-section"
                        [class.no-padding]="
                          formManager.countryDonatingFrom.value?.name === countryNames.UNITED_STATES
                            ? formManager.taxDeductionValue
                            : !formManager.taxDeductionValue"
                        [class.d-flex]="formManager.countryDonatingFrom.value?.name !== countryNames.UNITED_STATES">
                        @if (formManager.taxDeductionValue && formManager.countryDonatingFrom.value?.name !== countryNames.UNITED_STATES) {
                          <img
                            class="logo-network-member"
                            [src]="formManager.countryDonatingFrom.value.networkMember.logoUrl"
                            alt="Network Member Logo"
                          />
                          <div class="description-network-member">
                            {{ formManager.countryDonatingFrom.value.networkMember.description }}
                          </div>
                        }
                      </div>
                    } @else {
                      <div class="d-flex flex-wrap w-100 my-3 network-member-section"
                        [class.no-padding]="!formManager.taxDeductionValue">
                        @if (formManager.taxDeductionValue) {
                          <i
                            class="small"
                            [innerHTML]="
                              formManager.countryDonatingFrom.value.networkMember.description
                            "
                          ></i>
                        }
                      </div>
                    }
                  }

                  <!-- Network Member Info Boxes -->
                  @if (
                    dynamicData.displayNetworkMember &&
                    formManager.countryDonatingFrom.value?.networkMember &&
                    !countryFieldHasNoValue
                  ) {
                    @if (formManager.taxDeductionValue) {
                      @if (taxDeductibleMessage; as message) {
                        @if (!dynamicData.isNetworkMemberInfoLoading) {
                          <div class="info-box-network preserve-newlines">
                            {{
                              message
                                | translateLang
                                  : {
                                      minimumContribution:
                                        dynamicData.networkMemberMinimumContribution | number,
                                    }
                            }}
                          </div>
                        }
                      }
                      @if (dynamicData.warningMessage && !dynamicData.isNetworkMemberInfoLoading) {
                        <div
                          class="info-box-network"
                          [innerHTML]="
                            dynamicData.warningMessage
                              | translateLang: { email: constData.contactEmail }
                          "
                        ></div>
                      }
                      @if (additionalWarning) {
                        <div class="info-box-network">
                          {{ additionalWarning | translateLang }}
                        </div>
                      }
                    }
                  }

                  <!--
                    South Africa notice. Deliberately outside the network-member gates above:
                    contributions from South Africa are non-tax-deductible, so displayNetworkMember
                    and taxDeductionValue are both false and none of those blocks render.
                  -->
                  @if (isSouthAfricaContribution && !countryFieldHasNoValue) {
                    <div class="info-box-network preserve-newlines">
                      {{
                        'contribute.message.network_member.south_africa'
                          | translateLang: { min: southAfricaMinimumAmountDisplay }
                      }}
                    </div>
                  }
                </div>
              </div>
            }
            <!-- STEP Charity -->
            @if (constData.isPublic && allowsRecurring) {
              <div class="donate-form-section">
                <div class="d-flex align-items-start mb-3">
                  <span class="section-number">{{ constData.charityStepIndex }}</span>
                  <span class="section-title"
                    >{{ 'contribute.section2.title' | translateLang }}@if (isRequired(formManager.charity)) {<span class="section-title-required">*</span>}
                  </span>
                </div>

                <!-- Tax Deduction -->
                @if (constData.isTol) {
                  <div class="mt-3">
                    <app-select-field
                      [label]="'contribute.section2.tax_deduction.label'"
                      [placeholder]="'contribute.section2.tax_deduction.placeholder'"
                      [errorMessage]="'contribute.required'"
                      [options]="constData.taxDeductionOptions"
                      [optionLabel]="'value'"
                      [required]="isRequired(formManager.taxDeduction)"
                      [formControl]="formManager.taxDeduction"
                    />
                  </div>
                }
                @if (
                  formManager.isSwitzerlandWithCode &&
                  formManager.shouldShowOriginalDonorRecommendation
                ) {
                  <div class="my-4">
                    <app-text-input
                      [formControl]="formManager.specificCharity"
                      [label]="formManager.specificCharity.label"
                      [required]="isRequired(formManager.specificCharity)"
                      inputType="text"
                    />
                  </div>
                }
                <!-- Charity -->
                <app-charity-selector
                  label=""
                  [formControl]="formManager.charity"
                  [charities]="dynamicData.charitySearchResults"
                  [required]="isRequired(formManager.charity)"
                  (charitySearch)="onCharitySearch($event)"
                  (charitySelect)="onCharitySelect($event)"
                />
                @if (formManager.showCharityValidityError) {
                  <div class="small error-text">
                    {{ 'contribute.error.invalid_charity' | translateLang }}
                  </div>
                }
                @if (formManager.charity.value && !constData.customLink) {
                  <div class="charity-confirmation-box">
                    <p class="charity-confirmation-text">
                      {{ 'contribute.you_are_giving_to' | translateLang }}
                      <strong>{{ charityFundName | fundNameFormat }}</strong>
                    </p>
                  </div>
                }
                @if (
                  constData.isPublic && !constData.customLink && !constData.isApplicationAssessment
                ) {
                  <i
                    class="charity-fund-helper small"
                    [innerHTML]="
                      'contribute.section2.description'
                        | translateLang: { contact: constData.contactLink }
                    "
                  >
                  </i>
                }
              </div>
            }

            <!-- STEP Contribution Type -->
            @if (displayContributionTypeStep) {
              <div class="donate-form-section">
                <div class="d-flex align-items-start mb-3">
                  <span class="section-number">{{ constData.contributionTypeStepIndex }}</span>
                  <span class="section-title"
                    >{{ 'contribute.section3.title' | translateLang }}@if (isRequired(formManager.contributionType)) {<span class="section-title-required">*</span>}
                  </span>
                </div>

                <!-- Tax Deduction -->
                <div class="mt-3">
                  @if (constData.isTol && !constData.isPublic) {
                    <app-select-field
                      [label]="'contribute.section3.tax_deduction.label'"
                      [placeholder]="'contribute.section3.tax_deduction.placeholder'"
                      [errorMessage]="'contribute.required'"
                      [options]="constData.taxDeductionOptions"
                      [optionLabel]="'value'"
                      [required]="isRequired(formManager.taxDeduction)"
                      [formControl]="formManager.taxDeduction"
                    />
                  }
                </div>

                <!-- Contribution Type -->
                <div class="mt-3">
                  <app-select-field
                    label=""
                    [placeholder]="'contribute.section3.type.placeholder'"
                    [errorMessage]="'contribute.required'"
                    [required]="isRequired(formManager.contributionType)"
                    [options]="dynamicData.contributionTypeOptions"
                    [optionLabel]="'displayName'"
                    [formControl]="formManager.contributionType"
                  />
                </div>

                <!-- Recurring Contribution Checkbox (public only) -->
                @if (
                  (formManager.networkMember?.contriConfig?.enableRecurringContributions != null
                    ? formManager.networkMember?.contriConfig?.enableRecurringContributions &&
                      shouldShowPublicRecurring
                    : shouldShowPublicRecurring) && (hasPublicRecurringFlag$ | async)
                ) {
                  @if (
                    getContributionTypeCode() === contributionTypes.CREDIT_CARD ||
                    (((constData.isSwiss &&
                      (formManager.countryDonatingFrom.value?.name === countryNames.UNITED_STATES ||
                        formManager.countryDonatingFrom.value?.name === countryNames.BRAZIL)) ||
                      constData.isIgf) &&
                      getContributionTypeCode() === contributionTypes.BANK_TRANSFER_ONLINE)
                  ) {
                    <div class="recurring-contribution-checkbox mb-3">
                      <p-checkbox
                        [formControl]="publicRecurringCheckbox"
                        [binary]="true"
                        inputId="recurring-contribution"
                      />
                      <label for="recurring-contribution">
                        {{ 'contribute.recurring.checkbox_label' | translateLang }}
                      </label>
                    </div>
                  }
                }
                @if (dynamicData.contributionDetailsText) {
                  <div
                    class="info-box mt-0 mb-2"
                    [ngClass]="{ 'daf-info-box': formManager.dafProvider.visible }"
                  >
                    @if (!constData.isSinngeber) {
                      <p
                        class="mb-0"
                        [innerHTML]="
                          dynamicData.contributionDetailsText
                            | translateLang: { email: constData.contactEmail }
                            | translateCut: 0
                        "
                      ></p>
                    } @else {
                      @if (
                        constData.isPublic &&
                        getContributionTypeCode() === contributionTypes.DONOR_ADVISED_FUND
                      ) {
                        <p
                          [innerHTML]="
                            dynamicData.contributionDetailsText
                              | translateLang: { portalUrl: constData.portalLoginLink }
                              | translateCut: 0
                          "
                        ></p>
                        <p class="mb-1">
                          {{
                            dynamicData.contributionDetailsText | translateLang | translateCut: 1
                          }}
                        </p>
                      } @else {
                        <p class="mb-1">
                          {{
                            dynamicData.contributionDetailsText | translateLang | translateCut: 0
                          }}
                        </p>
                        <ul class="mb-1">
                          <li>
                            {{
                              dynamicData.contributionDetailsText | translateLang | translateCut: 1
                            }}
                          </li>
                          <li>
                            {{
                              dynamicData.contributionDetailsText | translateLang | translateCut: 2
                            }}
                          </li>
                          <li>
                            {{
                              dynamicData.contributionDetailsText | translateLang | translateCut: 3
                            }}
                          </li>
                        </ul>
                        <p
                          class="mb-1"
                          [innerHTML]="
                            dynamicData.contributionDetailsText
                              | translateLang: { portalUrl: constData.portalLoginLink }
                              | translateCut: 4
                          "
                        ></p>
                        <p
                          class="mb-1"
                          [innerHTML]="
                            dynamicData.contributionDetailsText
                              | translateLang: { homeUrl: constData.homepageLink }
                              | translateCut: 5
                          "
                        ></p>
                      }
                    }
                  </div>
                }

                <!-- Asset Description -->
                @if (formManager.assetDescription.visible) {
                  <div class="mt-3">
                    <app-text-input
                      [formControl]="formManager.assetDescription"
                      inputType="textarea"
                      label="donate.contribution.labels.asset.description"
                      [required]="true"
                      [maxlength]="280"
                      [rows]="3"
                      [showCharacterCount]="true"
                      inputId="asset-description"
                      [errorMessages]="{
                        required: 'validation.required',
                        maxlength: 'validation.max_length',
                      }"
                    />
                  </div>
                }
                @if (!isSinngeberGivingFund) {
                  <div class="row my-4">
                    <!-- Daf Provider -->
                    <div class="col-md-6 mb-4 mb-md-0">
                      @if (formManager.dafProvider.visible) {
                        <app-text-input
                          [formControl]="formManager.dafProvider"
                          label="donate.contribution.labels.daf.provider"
                          [required]="true"
                          [maxlength]="280"
                          [showCharacterCount]="true"
                          inputId="daf-provider"
                          [errorMessages]="{
                            required: 'donate.contribution.labels.daf.provider.error',
                            maxlength: 'validation.max_length',
                          }"
                        />
                      }
                    </div>
                    <!-- Fund Name -->
                    <div class="col-md-6">
                      @if (formManager.fundName.visible) {
                        <app-text-input
                          [formControl]="formManager.fundName"
                          label="donate.contribution.labels.fund.name"
                          [required]="true"
                          [maxlength]="280"
                          [showCharacterCount]="true"
                          inputId="fund-name"
                          [errorMessages]="{
                            required: 'donate.contribution.labels.fund.name.error',
                            maxlength: 'validation.max_length',
                          }"
                        />
                      }
                    </div>
                  </div>
                }
              </div>
            }

            <!--STEP Financial Information-->
            @if (displayFinancialStep) {
              <div class="donate-form-section">
                <div class="d-flex align-items-start mb-3">
                  <span class="section-number">{{ constData.financialStepIndex }}</span>
                  <span class="section-title"
                    >{{ 'contribute.section4.title' | translateLang }}
                    <!-- @if (isRequired(formManager.amount)) {<span class="section-title-required">*</span>} -->
                  </span>
                </div>

                <!-- Amount -->
                @if (
                  !constData.isPublic &&
                  formManager.isSwitzerlandWithCode &&
                  formManager.shouldShowOriginalDonorRecommendation
                ) {
                  <div class="my-4">
                    <app-text-input [formControl]="formManager.taxDeductionFund" [label]="formManager.taxDeductionFund.label" inputType="text" />
                    <div class="mt-3"></div>
                    <app-text-input
                      [formControl]="formManager.specificCharity"
                      [label]="formManager.specificCharity.label"
                      [required]="isRequired(formManager.specificCharity)"
                      inputType="text"
                    />
                    @if (formManager.showCharityValidityError) {
                      <div class="small error-text">
                        {{ 'contribute.error.invalid_charity' | translateLang }}
                      </div>
                    }
                  </div>
                }
                <!-- Amount & Currency -->
                <div class="mt-3">
                  <app-amount-currency-input
                    [formControl]="formManager.amountCurrency"
                    [currencySets]="dynamicData.availableCurrencies"
                    [minimumAmount]="getMinimumAmount()"
                    [required]="true"
                    [label]="formManager.amount.label"
                    [taxDeduction]="formManager.taxDeductionValue ? 'true' : null"
                    [contributionType]="formManager.contributionType.value?.code || null"
                    [isTaxDeductionAvailable]="dynamicData.displayTaxDeduction"
                    [currencyDisabled]="formManager.currency.disabled"
                    [hasError]="isCurrencyInvalidWithDelay"
                    [errorMessage]="southAfricaMinAmountError"
                    [selectionArrow]="true"
                    (focusout)="onCurrencyBlur()"
                  />
                </div>
                @if (formManager.isSag) {
                  <div class="break-word d-flex flex-wrap w-100 my-2">
                    <i>
                      <p
                        class="small"
                        [innerHTML]="
                          'contribute.info.sag_message' | translateLang: { email: adminEmail }
                        "
                      ></p>
                    </i>
                  </div>
                }

                <!--Anonymous donation-->
                @if (!isSwiss) {
                  <div class="my-4 d-flex pretty p-default p-curve">
                    <input
                      type="checkbox"
                      [formControl]="formManager.anonymousDonation"
                      class="generalCheckbox"
                      [attr.disabled]="
                        !constData.isPublic && isDAFOwner
                          ? allowAnonymousToOwnDAF
                            ? null
                            : true
                          : null
                      "
                    />
                    <div class="state p-primary">
                      <label class="ml-1 state p-primary">{{
                        formManager.anonymousDonation.label | translateLang
                      }}</label>
                    </div>
                  </div>
                }

                <!--Contribution Purpose -->
                <div class="my-4">
                  <app-text-input
                    [formControl]="formManager.contributionPurpose"
                    label="contribute.section4.purpose.label"
                    [placeholder]="formManager.contributionPurpose.placeholder"
                    [required]="isRequired(formManager.contributionPurpose)"
                    [maxlength]="250"
                    [showCharacterCount]="true"
                    inputId="contribution-purpose"
                    [errorMessages]="{
                      required: 'validation.required',
                      maxlength: 'validation.max_length',
                    }"
                  />
                </div>

                <!-- Recurring Form -->
                @if (isRecurring || isPublicRecurring) {
                  <app-recurring-form
                    [control]="formManager.recurrenceForm"
                    [dateFormat]="dateFormat"
                    [isStripe]="true"
                  ></app-recurring-form>
                }
              </div>
            }

            <!--STEP Giver Information-->
            @if (displayGiverInfoStep) {
              <div formGroupName="giverInfo">
                <div class="donate-form-section giver-info">
                  <div class="d-flex align-items-start mb-3">
                    <span class="section-number">{{ constData.giverInfoStepIndex }}</span>
                    <span class="section-title"
                      >{{ 'contribute.section5.title' | translateLang }}
                      <!-- @if (isRequired(formManager.firstName) || isRequired(formManager.email)) {<span class="section-title-required">*</span>} -->
                    </span>
                  </div>

                  <!-- Individual/Company -->
                  <div class="giver-info__radio-group">
                    <div class="giver-info__radio-option">
                      <p-radiobutton
                        [formControl]="formManager.isCompany"
                        [value]="false"
                        name="individual-company"
                        inputId="individual"
                      />
                      <label for="individual">
                        {{ 'contribute.section5.individual' | translateLang }}
                      </label>
                    </div>
                    <div class="giver-info__radio-option">
                      <p-radiobutton
                        [formControl]="formManager.isCompany"
                        [value]="true"
                        name="individual-company"
                        inputId="company"
                      />
                      <label for="company">
                        {{ 'contribute.section5.company' | translateLang }}
                      </label>
                    </div>
                  </div>

                  <!--Company name-->
                  @if (formManager.isCompany.value) {
                    <div class="giver-info__row giver-info__row--two-col">
                      <app-text-input
                        [formControl]="formManager.companyName"
                        label="contribute.section5.company_name"
                        [required]="true"
                        inputId="company-name"
                        [errorMessages]="{ required: 'contribute.section5.company_name.error' }"
                      />
                    </div>
                  }

                  <!-- Name Fields Row -->
                  <div class="giver-info__row giver-info__row--three-col">
                    <!-- First Name -->
                    <app-text-input
                      [formControl]="formManager.firstName"
                      label="contribute.section5.first_name"
                      [required]="true"
                      [maxlength]="30"
                      inputId="first-name"
                      [errorMessages]="{
                        required: 'contribute.section5.first_name.error',
                        lettersCharacters: 'contribute.section5.first_name.error.characters',
                        minLength: 'contribute.section5.first_name.error.min_length',
                      }"
                    />

                    <!-- Middle Name -->
                    <app-text-input
                      [formControl]="formManager.middleName"
                      label="contribute.section5.middle_name"
                      [maxlength]="30"
                      inputId="middle-name"
                    />

                    <!-- Last Name -->
                    <app-text-input
                      [formControl]="formManager.lastName"
                      label="contribute.section5.last_name"
                      [required]="true"
                      [maxlength]="30"
                      inputId="last-name"
                      [errorMessages]="{
                        required: 'contribute.section5.last_name.error',
                        lettersCharacters: 'contribute.section5.last_name.error.characters',
                        minLength: 'contribute.section5.last_name.error.min_length',
                      }"
                    />
                  </div>

                  <!-- Email Field -->
                  <div class="giver-info__row giver-info__row--full">
                    <app-text-input
                      [formControl]="formManager.email"
                      inputType="email"
                      label="contribute.section5.email"
                      [required]="true"
                      inputId="email"
                      [errorMessages]="{
                        required: 'contribute.section5.email.error.required',
                        email: 'contribute.section5.email.error.invalid',
                      }"
                    />
                  </div>

                  <!-- Country and City Row -->
                  <div class="giver-info__row giver-info__row--two-col">
                    <!-- Country -->
                    <app-country-selector
                      [formControl]="formManager.country"
                      [countries]="constData.countries"
                      [required]="true"
                      [hideRequiredInfo]="true"
                      [label]="'contribute.section1.country.label' | translateLang"
                      placeholder=""
                      errorMessage="contribute.section5.country.error"
                    />

                    <!-- City -->
                    <app-text-input
                      [formControl]="formManager.city"
                      label="contribute.section5.city"
                      [required]="true"
                      inputId="city"
                      [errorMessages]="{
                        required: 'contribute.section5.city.error',
                        numbersCharacters: 'contribute.section5.city.error.characters',
                      }"
                    />
                  </div>

                  <!-- Street, Province, Postal Row -->
                  <div class="giver-info__row giver-info__row--three-col">
                    <!-- Street Address -->
                    <app-text-input
                      [formControl]="formManager.streetAddress"
                      label="contribute.section5.street"
                      [required]="true"
                      [maxlength]="150"
                      inputId="street-address"
                      [errorMessages]="{
                        required: 'contribute.section5.street.error',
                        minLength: 'contribute.section5.street.error.min_length',
                      }"
                    />

                    <!-- Province / State -->
                    @if (formManager.stateProvince.type === inputTypes.DROPDOWN) {
                      <app-select-field
                        [formControl]="formManager.stateProvince"
                        label="contribute.section5.province"
                        placeholder="contribute.section5.province_placeholder"
                        errorMessage="contribute.required"
                        [options]="usStateOptions"
                        optionValue="name"
                        [required]="isRequired(formManager.stateProvince)"
                        [filter]="true"
                      />
                    } @else {
                      <app-text-input
                        [formControl]="formManager.stateProvince"
                        label="contribute.section5.province"
                        inputId="state-province"
                        [errorMessages]="{
                          minLength: 'contribute.section5.province.error.min_length',
                        }"
                      />
                    }

                    <!-- Postal Code -->
                    <app-text-input
                      [formControl]="formManager.postalCode"
                      label="contribute.section5.postal"
                      [required]="true"
                      [maxlength]="10"
                      inputId="postal-code"
                      [errorMessages]="{
                        required: 'contribute.section5.postal.error',
                        specialChars: 'contribute.section5.postal.error.characters',
                        minLength: 'contribute.section5.postal.error.min_length',
                      }"
                    />
                  </div>

                  <!-- Consent Section (Swiss Only) -->
                  @if (isSwiss) {
                    <section class="giver-info__consent">
                      <!-- Required indicator and title -->
                      <div class="giver-info__consent-header">
                        <app-icon
                          name="required-asterisk"
                          [size]="12"
                          class="giver-info__required-icon"
                        />
                        <p class="giver-info__consent-title">
                          {{ 'contribute.section5.consent.title' | translateLang }}
                        </p>
                      </div>

                      <!-- Anonymity radio options using PrimeNG -->
                      <div class="giver-info__radio-group">
                        <div class="giver-info__radio-option">
                          <p-radiobutton
                            [formControl]="formManager.shareDonorDetails"
                            [value]="anonymityOptions.NAME_EMAIL"
                            name="anonymity"
                            inputId="anonymity-name-email"
                          />
                          <label for="anonymity-name-email">
                            {{ 'contribute.section5.consent.name_and_email' | translateLang }}
                          </label>
                        </div>
                        <div class="giver-info__radio-option">
                          <p-radiobutton
                            [formControl]="formManager.shareDonorDetails"
                            [value]="anonymityOptions.NAME"
                            name="anonymity"
                            inputId="anonymity-name"
                          />
                          <label for="anonymity-name">
                            {{ 'contribute.section5.consent.name' | translateLang }}
                          </label>
                        </div>
                        <div
                          class="giver-info__radio-option"
                          [class.giver-info__radio-option--disabled]="formManager.disableAnonymous"
                          [pTooltip]="
                            'contribute.section5.consent.anonymous_tooltip' | translateLang
                          "
                          tooltipPosition="top"
                        >
                          <p-radiobutton
                            [formControl]="formManager.shareDonorDetails"
                            [value]="anonymityOptions.ANONYMOUS"
                            name="anonymity"
                            inputId="anonymity-anonymous"
                            [attr.aria-disabled]="formManager.disableAnonymous"
                          />
                          <label for="anonymity-anonymous">
                            {{ 'contribute.section5.consent.anonymous' | translateLang }}
                          </label>
                        </div>
                      </div>
                      @if (formManager.shareDonorDetails.invalid) {
                        <p class="giver-info__consent-error">
                          {{ 'contribute.section5.consent.required' | translateLang }}
                        </p>
                      }

                      <!-- Privacy Consent Box with Figma styling -->
                      @if (
                        formManager.shareDonorDetails.value && !formManager.anonymousDonation.value
                      ) {
                        <div class="giver-info__privacy-consent-box">
                          <p-checkbox
                            [formControl]="formManager.privacyConsent"
                            [binary]="true"
                            inputId="privacy-consent"
                          />
                          <div class="giver-info__privacy-consent-content">
                            <p class="giver-info__privacy-text">
                              <!-- <span class="required">* </span> -->
                              <span
                                [innerHTML]="
                                  'contribute.section5.consent.privacy_message' | translateLang
                                "
                              ></span>
                            </p>
                            @if (
                              formManager.privacyConsent.invalid &&
                              formManager.shareDonorDetails.value &&
                              !formManager.anonymousDonation.value
                            ) {
                              <p class="giver-info__privacy-warning">
                                {{
                                  'contribute.section5.consent.privacy_instruction' | translateLang
                                }}
                              </p>
                            }
                          </div>
                        </div>
                      }
                    </section>
                  }
                </div>
              </div>
            }
          </form>
        </div>
      }
    </div>

    <!-- Bank Details Section -->
    <div
      class="bank-details-section"
      [hidden]="
        !dynamicData.displayBankDetails || dynamicData.displaySummary || dynamicData.willRedirect
      "
    >
      <app-bank-details
        [onlineBanking]="constData.isCncf"
        [physicalCheck]="
          constData.isCncf &&
          formManager.contributionType.value?.code === contributionTypes.PHYSICAL_CHECK
        "
        [instructionIndex]="constData.isTol ? (formManager.taxDeductionValue ? 0 : 1) : null"
        [taxDeduction]="formManager.taxDeductionValue"
        [fundType]="formManager.charityValue?.fundType"
      ></app-bank-details>
    </div>
  </div>
  <!-- /.donate-layout-row -->
  @if (displayContributionSummary) {
    <app-summary-donation
      [displayData]="dynamicData.summaryData"
      [redirected]="constData.wasRedirected"
      [dateFormat]="dateFormat"
      [hasTaxDeductionFund]="
        formManager.isSwitzerlandWithCode && formManager.shouldShowOriginalDonorRecommendation
      "
      [fundName]="formManager.charityValue.name || formManager.charityValue.fundName"
    >
    </app-summary-donation>
  } @else {
    @if (constData.isSwiss && !dynamicData.willRedirect && dynamicData.swissContributionInfo) {
      <app-swiss-next-action
        [nextAction]="dynamicData.swissContributionInfo"
      ></app-swiss-next-action>
    }
  }

  <!-- Redirect Confirmation Dialog -->
  <app-redirect-confirmation-dialog
    [(visible)]="showRedirectDialog"
    [charityName]="charityNameOnly"
    [fundName]="formManager.charityValue?.fundName"
    [logoUrl]="formManager.countryDonatingFrom?.value?.networkMember?.logoUrl || redirectLogoUrl"
    [organizationName]="
      networkMemberRedirectUrl
        ? formManager.countryDonatingFrom?.value?.networkMember?.name || ''
        : redirectOrganizationName
    "
    [redirectTarget]="networkMemberRedirectUrl ? 'network_member' : dynamicData.redirectTarget"
    (confirm)="confirmRedirect()"
    (cancel)="closeRedirectDialog()"
  />

  @if (displayFooterSection) {
    <app-footer-section
      [fundName]="charityFundName"
      [customLink]="constData.customLink && !constData.isApplicationAssessment"
      [display]="true"
      [contributionType]="formManager.contributionType.value?.code"
      [isPublic]="constData.isPublic"
      [portalLoginLink]="constData.portalLoginLink"
      [homepageLink]="constData.homepageLink"
    >
    </app-footer-section>
  }
  @if (dynamicData.canDonate && !dynamicData.initiatedRedirect && !isSinngeberGivingFund) {
    @let selectedFund = coreFundService.selectedFund();
    @if (isAuthenticatedRoute && currentStepIndex !== 2 && selectedFund?.fundName) {
      <div class="auth-giving-to">
        <strong
          >{{ 'contribute.you_are_giving' | translateLang }}
          {{ selectedFund?.fundName | fundNameFormat }} (#{{ selectedFund?.fundNumber }})</strong
        >
      </div>
    }
    <!-- Step Counter (Mobile) -->
    <div class="step-counter">
      <span>{{
        'contribute.step_counter'
          | translateLang: { current: currentStepIndex + 1, total: stepperSteps.length }
      }}</span>
    </div>
    <div
      class="button-container-centered"
      [class.button-container-horizontal]="dynamicData.displaySummary"
    >
      @if (dynamicData.displaySummary || (dynamicData.willRedirect && !showRedirectDialog)) {
        <button type="button" class="lg-button form-back-button" (click)="handleBack()">
          {{ 'common.back' | translateLang }}
        </button>
      }
      <button
        [hidden]="dynamicData.submitted && !constData.isPublic"
        type="button"
        class="lg-button form-next-button"
        [disabled]="nextButtonDisabled"
        (click)="handleNext()"
      >
        {{ dynamicData.nextButtonText | translateLang }}
      </button>
    </div>
  }
} @else {
  <app-loading-overlay [visible]="true" [indeterminate]="true"></app-loading-overlay>
}

<!-- Portal toast container -->
<app-toast />
